// PublicApolloClient.js
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import config from '../config';

// Create a public version of Apollo Client
export const createPublicClient = () => {
  // Create cache
  const cache = new InMemoryCache({
    dataIdFromObject: o => o._id,
  });

  // Error handling link without auth dependency
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    }
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  // Simple upload link without auth headers
  const httpLink = createUploadLink({ 
    uri: config.api.url
  });

  // Create client
  return new ApolloClient({
    cache,
    link: ApolloLink.from([
      errorLink,
      httpLink
    ])
  });
};